import { MaskAccountNumberPipe } from '../../../../../_helpers/_pipes/mask-account-number.pipe';
import { BillingSidebarComponent } from '../../billing/billing-sidebar/billing-sidebar.component';
import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MailingAddressFastSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/mailing-address-svg/mailing-address-fast-svg.component';
import { MapfreAlertComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-alert/mapfre-alert.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Params , RouterModule } from '@angular/router';
import { PolicyDataService } from './../../../../../_services/data-services/policy-data.service';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { BillingDataService } from '../../../../../_services/data-services/billing-data.service';
import { LocationStrategy } from '@angular/common';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreAlertComponent, MailingAddressFastSvgComponent, MapfreButtonComponent, BillingSidebarComponent, MaskAccountNumberPipe],
  selector: 'app-payment-confirmation',
  templateUrl: './payment-confirmation.component.html',
  styleUrls: ['./payment-confirmation.component.scss'],
})
export class PaymentConfirmationComponent implements OnInit, OnDestroy {
  @Input() achGuestPayConfirm: boolean;
  billing: any;
  policyDetails: any;
  policyId: any;
  isAcmic: boolean;

  constructor(
    private billingDataService: BillingDataService,
    private policyDataService: PolicyDataService,
    private activatedRoute: ActivatedRoute,
    private location: LocationStrategy,
    private acmicService: AcmicService
  ) {
    this.isAcmic = false;
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    if (!this.achGuestPayConfirm) {
      history.pushState(null, null, window.location.href);
      this.location.onPopState(() => {
        history.pushState(null, null, window.location.href);
      });
    }
    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyId = params['policyid'];
      this.policyDataService.$policyDetails.subscribe((policyResponse) => {
        this.policyDetails = policyResponse;
      });
      this.billingDataService.$billingDetailsEcheck.subscribe((billing) => {
        this.billing = billing;
      });
    });
  }

  ngOnDestroy() {
    this.billingDataService.clearCheckingAccount();
  }
}
